import { listen, sendLocal } from "../channels";
import { filterMessage } from "../helpers";
import { isData } from "../message";
import { isMfeConfigMessage } from "../messages/mfe-config";
import { mfeConfigRequestMessage } from "../messages/mfe-config-request";
export var getMfeConfig = function getMfeConfig(name) {
  return new Promise(function (res, rej) {
    var timeOut = setTimeout(function () {
      return rej("getMfeConfig timed out");
    }, 10 * 1000);
    var unsub = listen(filterMessage(isMfeConfigMessage)(function (message) {
      if (isData(message) && message.payload.name === name) {
        var mfeConfig = message.payload;
        unsub();
        clearTimeout(timeOut);
        res(mfeConfig);
      }
    }));
    sendLocal(mfeConfigRequestMessage({
      name: name
    }));
  });
};